import "../../pages/new/new.scss"

import axiosInstance from '../../api/axios';
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, useLocation  } from 'react-router-dom';
import { Container, TextField, Button, Box } from '@mui/material';

export const StudentInfo = ({ studentData, onChange, viewMode }) => {
  const navigate = useNavigate();
  const [student, setStudent] = useState(studentData);
  const [errors, setErrors] = useState({});
  const [resetPasswordResult, setResetPasswordResult] = useState(null);
  const [resettingPassword, setResettingPassword] = useState(false);
  useEffect(() => {
    setStudent(studentData);
  }, [studentData]);
 // console.log(studentData);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setStudent({ ...student, [name]: value });
    onChange({ ...student, [name]: value });
  };
  const validateForm = () => {
    const errors = {};
    if (!student.enrollmentNumber) {
      errors.enrollmentNumber = 'enrollmentNumber is required';
    }
    if (!student.name) {
      errors.name = 'name is required';
    }
    if (!student.dob) {
      errors.dob = 'dob is required';
    }
    if (!student.gender) {
      errors.gender = 'gender is required';
    }
    if (!student.nationality) {
      errors.nationality = 'nationality is required';
    }
    if (!student.contactNumber) {
      errors.contactNumber = 'contactNumber is required';
    }
    if (!student.email) {
      errors.email = 'email is required';
    }
    if (!student.currentAddress) {
      errors.currentAddress = 'currentAddress is required';
    }
    if (!student.bloodGroup) {
      errors.bloodGroup = 'bloodGroup is required';
    }
    if (!student.status) {
      errors.status = 'status is required';
    }
    if (!student.fatherName) {
      errors.fatherName = 'fatherName is required';
    }
    if (!student.motherName) {
      errors.motherName = 'motherName is required';
    }
    if (!student.permanentAddress) {
      errors.permanentAddress = 'permanentAddress is required';
    }
    if (!student.ugDegree) {
      errors.ugDegree = 'ugDegree is required';
    }
    setErrors(errors);
    return Object.keys(errors).length === 0;
  };
  const handleResetPassword = async () => {
    if (!student.email) return;
    if (!window.confirm(`Reset the login password for ${student.email}? Their current password will stop working immediately.`)) {
      return;
    }
    setResettingPassword(true);
    try {
      const response = await axiosInstance.post(
        `/auth/reset-password?email=${encodeURIComponent(student.email)}`
      );
      setResetPasswordResult(response.data.data);
    } catch (error) {
      console.error('Error resetting password:', error);
    } finally {
      setResettingPassword(false);
    }
  };
  const handleSubmit = async(e) => {
    e.preventDefault();
    if (!validateForm()) return;
    try {
      if (viewMode) {
          navigate('/students');
      }

      else  {
          
          // Update course if in edit mode
         var response = await axiosInstance.put('/students', student, { showToastOnResponse: true });
      }
      navigate('/students');

    } catch (error) {
        console.log('Error saving feedback. Please try again later.');
        console.log(error);
    }
    // Handle form submission, maybe send data to the parent or a server
   // console.log('Form submitted:', student);
  };
  return (
    <div className="bottom">
      <div className="left"></div>
      <div className="right">
        <form onSubmit={handleSubmit}>
          <div className="formInput">
            <label>Enrollment Number </label>
            <input type="text"
              name="enrollmentNumber"
              value={student.enrollmentNumber}
              onChange={handleChange}
              readOnly={true}
              className={errors.enrollmentNumber ? 'error' : ''} />
            {errors.enrollmentNumber && <div className="error-text">{errors.enrollmentNumber}</div>}
          </div>
          <div className="formInput">
            <label>name</label>
            <input type="text"
              name="name"
              value={student.name}
              readOnly={viewMode}
              onChange={handleChange}
              className={errors.name ? 'error' : ''} />
            {errors.name && <div className="error-text">{errors.name}</div>}
          </div>
          <div className="formInput">
            <label>Date of Birth</label>
            <input
              type="dob"
              id="dob"
              name="dob"
              readOnly={viewMode}
              value={student.dob}
              onChange={handleChange}
            />
            {errors.dob && <div className="error-text">{errors.dob}</div>}
          </div>
          <div className="formInput">
            <label>gender</label>
            <select id="styled-dropdown"
              name="gender"
              value={student.gender}
              onChange={handleChange}
              disabled={viewMode}
              className={errors.gender ? 'error' : ''}>
              <option value="male">male</option>
              <option value="female">female</option>
              <option value="other">other</option>
              <option value="noreveal">noreveal</option>
            </select>
            {errors.gender && <div className="error-text">{errors.gender}</div>}
          </div>


          <div className="formInput">
            <label>nationality </label>
            <input type="text"
              name="nationality"
              value={student.nationality}
              onChange={handleChange}
              readOnly={true}
              className={errors.nationality ? 'error' : ''} />
            {errors.nationality && <div className="error-text">{errors.nationality}</div>}
          </div>
          <div className="formInput">
            <label>contactNumber</label>
            <input type="text"
              name="contactNumber"
              value={student.contactNumber}
              readOnly={viewMode}
              onChange={handleChange}
              className={errors.contactNumber ? 'error' : ''} />
            {errors.contactNumber && <div className="error-text">{errors.contactNumber}</div>}
          </div>

          <div className="formInput">
            <label>alternateContactNumber </label>
            <input type="text"
              name="alternateContactNumber"
              value={student.alternateContactNumber}
              onChange={handleChange}
              readOnly={true}
              className={errors.alternateContactNumber ? 'error' : ''} />
            {errors.alternateContactNumber && <div className="error-text">{errors.alternateContactNumber}</div>}
          </div>
          <div className="formInput">
            <label>email</label>
            <input type="text"
              name="email"
              value={student.email}
              readOnly={viewMode}
              onChange={handleChange}
              className={errors.email ? 'error' : ''} />
            {errors.email && <div className="error-text">{errors.email}</div>}
          </div>

          {!viewMode && student.email && (
            <div className="formInput">
              <button type="button" onClick={handleResetPassword} disabled={resettingPassword}>
                {resettingPassword ? 'Resetting...' : 'Reset Login Password'}
              </button>
              {resetPasswordResult && (
                <div style={{ marginTop: 8, padding: 10, border: '1px solid #d0d0d0', background: '#fafafa' }}>
                  <div>New password for <strong>{resetPasswordResult.username}</strong>:</div>
                  <div style={{ fontFamily: 'monospace', fontSize: '1.1em', margin: '6px 0' }}>
                    {resetPasswordResult.temporaryPassword}
                  </div>
                  <div style={{ fontSize: '0.85em', color: '#a33' }}>
                    Shown once - copy it now and share it with them directly. It cannot be retrieved again after you leave this page.
                  </div>
                </div>
              )}
            </div>
          )}

          <div className="formInput">
            <label>status</label>
            <input type="text"
              name="status"
              value={student.status}
              readOnly={viewMode}
              onChange={handleChange}
              className={errors.status ? 'error' : ''} />
            {errors.status && <div className="error-text">{errors.status}</div>}
          </div>


          <div className="formInput">
            <label>fatherName</label>
            <input type="text"
              name="fatherName"
              value={student.fatherName}
              readOnly={viewMode}
              onChange={handleChange}
              className={errors.fatherName ? 'error' : ''} />
            {errors.fatherName && <div className="error-text">{errors.fatherName}</div>}
          </div>

          <div className="formInput">
            <label>motherName</label>
            <input type="text"
              name="motherName"
              value={student.motherName}
              readOnly={viewMode}
              onChange={handleChange}
              className={errors.motherName ? 'error' : ''} />
            {errors.motherName && <div className="error-text">{errors.motherName}</div>}
          </div>

          <div className="formInput">
            <label>currentAddress</label>
            <input type="text"
              name="currentAddress"
              value={student.currentAddress}
              readOnly={viewMode}
              onChange={handleChange}
              className={errors.currentAddress ? 'error' : ''} />
            {errors.currentAddress && <div className="error-text">{errors.currentAddress}</div>}
          </div>
          <div className="formInput">
            <label>permanentAddress</label>
            <input type="text"
              name="permanentAddress"
              value={student.permanentAddress}
              readOnly={viewMode}
              onChange={handleChange}
              className={errors.permanentAddress ? 'error' : ''} />
            {errors.permanentAddress && <div className="error-text">{errors.permanentAddress}</div>}
          </div>

          <div className="formInput">
            <label>bloodGroup</label>
            <input type="text"
              name="bloodGroup"
              value={student.bloodGroup}
              readOnly={viewMode}
              onChange={handleChange}
              className={errors.bloodGroup ? 'error' : ''} />
            {errors.bloodGroup && <div className="error-text">{errors.bloodGroup}</div>}
          </div>

          <div className="formInput">
            <label>ugDegree</label>
            <input type="text"
              name="ugDegree"
              value={student.ugDegree}
              readOnly={viewMode}
              onChange={handleChange}
              className={errors.ugDegree ? 'error' : ''} />
            {errors.ugDegree && <div className="error-text">{errors.ugDegree}</div>}
          </div>

          <div className="formInput">
            <label>ugDiscipline</label>
            <input type="text"
              name="ugDiscipline"
              value={student.ugDiscipline}
              readOnly={viewMode}
              onChange={handleChange}
              className={errors.ugDiscipline ? 'error' : ''} />
            {errors.ugDiscipline && <div className="error-text">{errors.ugDiscipline}</div>}
          </div>

          <div className="formInput">
            <label>ugUniversity</label>
            <input type="text"
              name="ugUniversity"
              value={student.ugUniversity}
              readOnly={viewMode}
              onChange={handleChange}
              className={errors.ugUniversity ? 'error' : ''} />
            {errors.ugUniversity && <div className="error-text">{errors.ugUniversity}</div>}
          </div>

          <div className="formInput">
            <label>ugGraduationYear</label>
            <input type="text"
              name="ugGraduationYear"
              value={student.ugGraduationYear}
              readOnly={viewMode}
              onChange={handleChange}
              className={errors.ugGraduationYear ? 'error' : ''} />
            {errors.ugGraduationYear && <div className="error-text">{errors.ugGraduationYear}</div>}
          </div>

          <div className="formInput">
            <label>ugProgramDuration</label>
            <input type="text"
              name="ugProgramDuration"
              value={student.ugProgramDuration}
              readOnly={viewMode}
              onChange={handleChange}
              className={errors.ugProgramDuration ? 'error' : ''} />
            {errors.ugProgramDuration && <div className="error-text">{errors.ugProgramDuration}</div>}
          </div>

          <div className="formInput">
            <label>ugPercentCGPA</label>
            <input type="text"
              name="ugPercentCGPA"
              value={student.ugPercentCGPA}
              readOnly={viewMode}
              onChange={handleChange}
              className={errors.ugPercentCGPA ? 'error' : ''} />
            {errors.ugPercentCGPA && <div className="error-text">{errors.ugPercentCGPA}</div>}
          </div>

          <div className="formInput">
            <label>ugSecuredPercentCGPA</label>
            <input type="text"
              name="ugSecuredPercentCGPA"
              value={student.ugSecuredPercentCGPA}
              readOnly={viewMode}
              onChange={handleChange}
              className={errors.ugSecuredPercentCGPA ? 'error' : ''} />
            {errors.ugSecuredPercentCGPA && <div className="error-text">{errors.ugSecuredPercentCGPA}</div>}
          </div>

          <div className="formInput">
            <label>ugPercentCGPAOutOf</label>
            <input type="text"
              name="ugPercentCGPAOutOf"
              value={student.ugPercentCGPAOutOf}
              readOnly={viewMode}
              onChange={handleChange}
              className={errors.ugPercentCGPAOutOf ? 'error' : ''} />
            {errors.ugPercentCGPAOutOf && <div className="error-text">{errors.ugPercentCGPAOutOf}</div>}
          </div>


          <div className="formInput">
            <label>pgDegree</label>
            <input type="text"
              name="pgDegree"
              value={student.pgDegree}
              readOnly={viewMode}
              onChange={handleChange}
              className={errors.pgDegree ? 'error' : ''} />
            {errors.pgDegree && <div className="error-text">{errors.pgDegree}</div>}
          </div>

          <div className="formInput">
            <label>pgDiscipline</label>
            <input type="text"
              name="pgDiscipline"
              value={student.pgDiscipline}
              readOnly={viewMode}
              onChange={handleChange}
              className={errors.pgDiscipline ? 'error' : ''} />
            {errors.pgDiscipline && <div className="error-text">{errors.pgDiscipline}</div>}
          </div>

          <div className="formInput">
            <label>pgUniversity</label>
            <input type="text"
              name="pgUniversity"
              value={student.pgUniversity}
              readOnly={viewMode}
              onChange={handleChange}
              className={errors.pgUniversity ? 'error' : ''} />
            {errors.pgUniversity && <div className="error-text">{errors.pgUniversity}</div>}
          </div>


          <div className="formInput">
            <label>pgGraduationYear</label>
            <input type="text"
              name="pgGraduationYear"
              value={student.pgGraduationYear}
              readOnly={viewMode}
              onChange={handleChange}
              className={errors.pgGraduationYear ? 'error' : ''} />
            {errors.pgGraduationYear && <div className="error-text">{errors.pgGraduationYear}</div>}
          </div>

          <div className="formInput">
            <label>pgProgramDuration</label>
            <input type="text"
              name="pgProgramDuration"
              value={student.pgProgramDuration}
              readOnly={viewMode}
              onChange={handleChange}
              className={errors.pgProgramDuration ? 'error' : ''} />
            {errors.pgProgramDuration && <div className="error-text">{errors.pgProgramDuration}</div>}
          </div>


          <div className="formInput">
            <label>pgPercentCGPA</label>
            <input type="text"
              name="pgPercentCGPA"
              value={student.pgPercentCGPA}
              readOnly={viewMode}
              onChange={handleChange}
              className={errors.pgPercentCGPA ? 'error' : ''} />
            {errors.pgPercentCGPA && <div className="error-text">{errors.pgPercentCGPA}</div>}
          </div>

          <div className="formInput">
            <label>pgSecuredPercentCGPA</label>
            <input type="text"
              name="pgSecuredPercentCGPA"
              value={student.pgSecuredPercentCGPA}
              readOnly={viewMode}
              onChange={handleChange}
              className={errors.pgSecuredPercentCGPA ? 'error' : ''} />
            {errors.pgSecuredPercentCGPA && <div className="error-text">{errors.pgSecuredPercentCGPA}</div>}
          </div>

          <div className="formInput">
            <label>pgPercentCGPAOutOf</label>
            <input type="text"
              name="pgPercentCGPAOutOf"
              value={student.pgPercentCGPAOutOf}
              readOnly={viewMode}
              onChange={handleChange}
              className={errors.pgPercentCGPAOutOf ? 'error' : ''} />
            {errors.pgPercentCGPAOutOf && <div className="error-text">{errors.pgPercentCGPAOutOf}</div>}
          </div>


          <div className="formInput">
            <label>totalWorkExperience</label>
            <input type="text"
              name="totalWorkExperience"
              value={student.totalWorkExperience}
              readOnly={viewMode}
              onChange={handleChange}
              className={errors.totalWorkExperience ? 'error' : ''} />
            {errors.totalWorkExperience && <div className="error-text">{errors.totalWorkExperience}</div>}
          </div>

          <div className="formInput">
            <label>totalAIWorkExperience</label>
            <input type="text"
              name="totalAIWorkExperience"
              value={student.totalAIWorkExperience}
              readOnly={viewMode}
              onChange={handleChange}
              className={errors.totalAIWorkExperience ? 'error' : ''} />
            {errors.totalAIWorkExperience && <div className="error-text">{errors.totalAIWorkExperience}</div>}
          </div>
          <div className="formInput">
            <label>company</label>
            <input type="text"
              name="company"
              value={student.company}
              readOnly={viewMode}
              onChange={handleChange}
              className={errors.company ? 'error' : ''} />
            {errors.company && <div className="error-text">{errors.company}</div>}
          </div>

          <div className="formInput">
            <label>batch</label>
            <input type="text"
              name="batch"
              value={student.batch}
              readOnly={viewMode}
              onChange={handleChange}
              className={errors.batch ? 'error' : ''} />
            {errors.batch && <div className="error-text">{errors.batch}</div>}
          </div>

          <div className="buttons">
            {!viewMode && <button type="submit">{ 'Update'}</button>}
          </div>
        </form>
      </div>
    </div>
  );
};